function Events() {
    return (
        <div>

            <div style={{ height: "20vh" }}></div>

            <section>
                <div className="masked">
                    <img src="/assets/IMG_5740-removebg-preview.png" alt="Jaiye party logo" className="party-logo-images" width="700" height="210" data-aos="fade-up" />
                    <ul>
                        <li><img src="/assets/IMG_5745.jpeg" alt="" className="small-image" data-aos="fade-up" /></li>
                        <li><img src="/assets/IMG_5744.jpeg" alt="" className="small-image" data-aos="fade-up" /></li>
                        <li><img src="/assets/IMG_5746.jpeg" alt="" className="small-image" data-aos="fade-up" /></li>
                    </ul>
                </div>
            </section>

            {/*<section>
                <div className="lasgidi">
                    <img src="/assets/image-removebg-preview.png" alt="Lasgidi party logo" className="party-logo-images" width="700" height="210" data-aos="fade-up" />
                </div>
            </section>*/}

            <section>
                <div className="jaiye">
                    <img src="/assets/IMG_5737-removebg-preview.png" alt="Party logo" className="party-logo-images" width="500" height="150" data-aos="fade-up" />
                    <ul>
                        <li><img src="/assets/IMG_5738.jpeg" alt="" className="small-image" data-aos="fade-up" /></li>
                        <li><img src="/assets/IMG_5739.jpeg" alt="" className="small-image" data-aos="fade-up" /></li>
                        <li><img src="/assets/IMG_5734.jpeg" alt="" className="small-image" data-aos="fade-up" /></li>
                    </ul>
                </div>
            </section>

            <div style={{ height: "5vh" }}></div>

            <section>
                <div className="italawa">
                    <img src="/assets/IMG_5748-removebg-preview.png" alt="" className="party-logo-images" width="700" height="150" data-aos="fade-up" />
                    <ul>
                        <li><img src="/assets/IMG_5749.jpeg" alt="" className="small-image" data-aos="fade-up" /></li>
                        <li><img src="/assets/IMG_5751.jpeg" alt="" className="small-image" data-aos="fade-up" /></li>
                        <li>
                            <video className="small-image" controls>
                                <source src="/assets/italawavideo2.mp4" type="video/mp4" />
                                Your browser does not support the video tag.
                            </video>
                        </li>
                    </ul>
                </div>
                <div style={{ height: "5vh" }}></div>
            </section>
        </div>
    );
}

export default Events;